import useModal from "../../useModal";
import UseContext from "../../../../hooks/useContext";
import Modalheader from "../../components/header";
import ModalBody from "../../components/body";
import ModalFooter from "../../components/footer";
import Button from "../../../../components/button";
import SubmitButton from "../../../../components/button/SubmitButton";
import StyledInput from "../../../../components/styledInput/StyledInput";
import React, { useEffect, useMemo, useState } from "react";
import ApiDatabase from "../../../../server";

const ModalCreateQualificationSimpleSettings = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSuccess = modalData?.onSuccess;

  useEffect(() => {
    setName("");
    setError("");
    setSubmitting(false);
  }, [modalData]);

  const canSubmit = useMemo(() => name.trim().length > 0, [name]);

  const handleSubmit = () => {
    if (!canSubmit) return;
    setSubmitting(true);
    setError("");
    ApiDatabase.postCreateQualification(
      { name: name.trim() },
      () => {
        setSubmitting(false);
        setModalDataReturn({ qualifications: true });
        if (onSuccess) onSuccess();
        toggle();
      },
      (err) => {
        setSubmitting(false);
        setError(
          err?.response?.data?.message ||
            "Impossible de créer ce poste."
        );
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Créer un poste
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4">
          <StyledInput
            type="text"
            label="Nom du poste"
            placeholder="Ex : manutentionnaire"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {error ? <div className="ft-sm text-red-600">{error}</div> : null}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="SECONDARY" size="LG" onClick={toggle}>
          Annuler
        </Button>
        <SubmitButton
          loading={submitting}
          disabled={!canSubmit}
          onClick={handleSubmit}
        />
      </ModalFooter>
    </>
  );
};

export default ModalCreateQualificationSimpleSettings;
